import { ILocalDatabase, ITable, Table } from 'utility-ts-database';

const localDatabase: ILocalDatabase = new Table<any>('local');

angular.module('utility-ng-database', [])
  .constant('Table', Table)
  .provider('localDatabase', () => {
    return {
      $get: () => localDatabase
    }
  });



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-database/dist/main.ts